<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'AttendanceLineChart',
  extends: Line,
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted() {
        this.renderChart(this.chartData, this.chartOptions)
    },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newData) {
        const labels = newData.map(item => item.full_name)
        const present = newData.map(item => item.present)
        const absent = newData.map(item => item.absent)

        this.chartData = {
          labels,
          datasets: [
            {
              label: 'Present',
              borderColor: 'green',
              backgroundColor: 'rgba(0,128,0,0.2)',
              data: present,
              tension: 0.3,
              fill: true
            },
            {
              label: 'Absent',
              borderColor: 'red',
              backgroundColor: 'rgba(255,0,0,0.2)',
              data: absent,
              tension: 0.3,
              fill: true
            }
          ]
        }
      }
    }
  }
}
</script>
